import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=67be9e69"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=67be9e69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports